export enum InventoryRelationshipCreationMethod {
    Manually = 'Manually',
    Automatically = 'Automatically'
}